import EmptyStateProps from '../utils/EmptyStateProps';
import getDisplayPropertiesForEmptyList from '../utils/getDisplayPropertiesForEmptyList';
import { observer } from 'mobx-react';
import { isBulkActionRunning, isBulkActionUninitialized } from 'owa-bulk-action-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getFocusedFilterForTable } from 'owa-mail-list-store';
import { listViewStore } from 'owa-mail-list-store';
import { MessageAdList } from 'owa-mail-messagead-list-view';
import isReadingPaneBottom from 'owa-mail-reading-pane-store/lib/utils/isReadingPaneBottom';
import { ActionSource } from 'owa-mail-store';
import { MailListViewState } from 'owa-mail-store/lib/store/schema/MailListViewState';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';

const classNames = require('classnames');
const styles = require('./MailListEmptyState.scss');

export interface EmptyListViewProps {
    tableViewId: string;
    stateType: MailListViewState;
    clearFilterCommand: (actionSource: ActionSource) => void;
    reloadCommand: (actionSource: ActionSource) => void;
    shouldShowMessageAdList: boolean;
}

@observer
export default class MailListEmptyState extends React.Component<EmptyListViewProps, {}> {
    render() {
        const { tableViewId, stateType, clearFilterCommand, reloadCommand } = this.props;

        let emptyState: EmptyStateProps = {
            mainMessage: null,
            detailMessage: null,
            linkMessage: null,
            linkCommand: null,
            icon: null,
        };

        emptyState = getDisplayPropertiesForEmptyList(
            tableViewId,
            stateType,
            clearFilterCommand,
            reloadCommand
        );

        const messageContainerClassNames = classNames(
            styles.infoMessageContainer,
            isReadingPaneBottom() ? styles.isReadingPaneBottom : ''
        );

        const mainMessageClassNames = classNames(styles.messageText, styles.mainMessageText);

        const detailMessageClassNames = classNames(styles.messageText, styles.detailsMessageText);

        const linkMessageClassNames = classNames(styles.messageText, styles.linkMessageText);

        let isBulkAction = false; // Assume no bulk action is running by default

        if (isFeatureEnabled('tri-bulkActionNotification')) {
            const tableView = listViewStore.tableViews.get(tableViewId);
            const folderId = tableView.tableQuery.folderId;
            isBulkAction = isBulkActionRunning(folderId) || isBulkActionUninitialized(folderId);
        }

        // Only fire the native ad when the listview state is really empty. Sometimes, this is in the loading state.
        const needShowMessageAdList =
            this.props.shouldShowMessageAdList && this.props.stateType == MailListViewState.Empty;
        return (
            <>
                {needShowMessageAdList && (
                    <div className={styles.adContainer}>
                        <MessageAdList
                            loadInOtherPivot={
                                getFocusedFilterForTable(
                                    listViewStore.tableViews.get(tableViewId)
                                ) == FocusedViewFilter.Other
                            }
                            loadInEmptyPivot={true}
                        />
                    </div>
                )}
                {!needShowMessageAdList && (
                    <div className={messageContainerClassNames}>
                        {emptyState.icon && (
                            <img src={emptyState.icon} width="120px" height="120px" />
                        )}
                        {emptyState.mainMessage && (
                            <div className={mainMessageClassNames}>
                                {isBulkAction
                                    ? strings.folderIsBeingEmptied
                                    : emptyState.mainMessage}
                            </div>
                        )}
                        {emptyState.detailMessage && (
                            <div className={detailMessageClassNames}>
                                {emptyState.detailMessage}
                            </div>
                        )}
                        {emptyState.linkMessage && (
                            <div
                                className={linkMessageClassNames}
                                onClick={() => {
                                    emptyState.linkCommand('EmptyListState');
                                }}>
                                {emptyState.linkMessage}
                            </div>
                        )}
                    </div>
                )}
            </>
        );
    }
}
